import {UserSessionService} from "../user-session/user-session.service";
import {PreferenceService} from "../preference/preference.service";
import {TestprepRootScope} from "../../models/testprep-rootscope.model";

export class ModalWindowController {
    large: string;
    value: boolean;
    showModal: boolean;
    currentPage: number = 1;
    visibleContent: number = 0;
    neverShow: boolean;
    
    /* @ngInject */
    constructor(private userSessionService: UserSessionService,
                private preferenceService: PreferenceService,
                private $rootScope: TestprepRootScope) {
        this.showModal = this.userSessionService.showWelcomeModal();
    }
    
    isFinalSlide(): boolean { return this.visibleContent === 4; }

    isContentVisible(content: number): boolean { return content === this.visibleContent; }

    nextContent(): void {
        if(this.visibleContent !== 4) {
            this.visibleContent++;
        } else {
            this.closeThisModal();
        }
    }

    prevContent(): void { this.visibleContent--; }

    closeThisModal(): void {
        this.showModal = false;
        this.userSessionService.setHideWelcomeModal();
        if (this.neverShow) {
            this.preferenceService.setUserPreference({ testprepWelcomeModal: false })
                .then(this.preferenceServiceResponse);
        }
    }

    private preferenceServiceResponse = (status: number): void => {
        if (status >= 400) { this.$rootScope.loadingError = true; }
    };
}


/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/common/modal-window/modal-window.controller.ts
 **/